import { render, staticRenderFns } from "./_mgb-multiselect.vue?vue&type=template&id=6c6b7660&scoped=true&"
import script from "./_mgb-multiselect.vue?vue&type=script&lang=js&"
export * from "./_mgb-multiselect.vue?vue&type=script&lang=js&"
import style0 from "./_mgb-multiselect.vue?vue&type=style&index=0&id=6c6b7660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b7660",
  null
  
)

export default component.exports